import Joi from 'joi';

export const UserDetailsSchema = Joi.object({
  firstName: Joi.string().trim().min(1).max(100).required().messages({
    'any.required': 'First name is required.',
    'string.base': 'First name is invalid.',
    'string.empty': 'First name is invalid.',
    'string.min': 'First name must have at most 100 characters only.',
    'string.max': 'First name must have at most 100 characters only.',
  }),
  middleName: Joi.string().trim().min(1).max(100).optional().messages({
    'string.base': 'Middle name is invalid.',
    'string.empty': 'Middle name is invalid.',
    'string.min': 'Middle name must have at most 100 characters only.',
    'string.max': 'Middle name must have at most 100 characters only.',
  }),
  noMiddleName: Joi.any(),
  lastName: Joi.string().trim().min(1).max(100).required().messages({
    'any.required': 'Last name is required.',
    'string.base': 'Last name is invalid.',
    'string.empty': 'Last name is invalid.',
    'string.min': 'Last name must have at most 100 characters only.',
    'string.max': 'Last name must have at most 100 characters only.',
  }),
  userEmail: Joi.string().trim().max(100).required().messages({
    'any.required': 'Email is required.',
    'string.base': 'Email is invalid.',
    'string.empty': 'Email is invalid.',
    'string.min': 'Email must have at most 100 characters only.',
    'string.max': 'Email must have at most 100 characters only.',
  }),
  username: Joi.string().trim().min(1).max(50).required().messages({
    'any.required': 'Username is required.',
    'string.base': 'Username is invalid.',
    'string.empty': 'Username is invalid.',
    'string.min': 'Username must have at most 50 characters only.',
    'string.max': 'Username must have at most 50 characters only.',
  }),
  // 22 characters for password results to 44 character ciphertext
  // Note: Database password max characters is 50
  password: Joi.string()
    .trim()
    .min(8)
    .max(22)
    .pattern(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{7,}$/)
    .required()
    .messages({
      'any.required': 'Password is required.',
      'string.base': 'Password is invalid.',
      'string.pattern.base':
        'Password must have at least 1 uppercase and lowercase character, a number, and special character.',
      'string.empty': 'Password is invalid.',
      'string.min': 'Password must have 8 to 22 characters only.',
      'string.max': 'Password must have 8 to 22 characters only.',
    }),
  confirmPassword: Joi.any().valid(Joi.ref('password')).messages({
    'any.only': 'Passwords do not match.',
  }),
});
